import i18next from 'i18next';
import { numberValidate, phraseValidate } from '../utils/regex';

export const validate = values => {
  const errors = {};

  // name

  if (!values.name) {
    errors.name = i18next.t('name_validate_secondary');
  } else if (values.name.length < 2) {
    errors.name = i18next.t('at_least_two_characters');
  } else if (values.name.length >= 32) {
    errors.name = i18next.t('no_more_thirty_characters');
  }

  //   asset

  if (values.assets === null) {
    errors.assets = i18next.t('validate_asset');
  }

  // timezone
  if (values.timezone.id === '') {
    errors.timezone = i18next.t('timezone_validate');
  }

  //   description

  if (!values.description) {
    errors.description = i18next.t('description_validate');
  } else if (values.description.length < 2) {
    errors.description = i18next.t('at_least_two_characters');
  }

  //   address

  if (!values.address) {
    errors.address = i18next.t('address_validate');
  } else if (values.address.length < 2) {
    errors.address = i18next.t('at_least_two_characters');
  } else if (values.address.length >= 150) {
    errors.address = i18next.t('no_more_than_150');
  }

  // Accommodation

  if (!values.food_accommodation?.length && !values.isAllAccomodation) {
    errors.food_accommodation = i18next.t('select_accommodation');
  }

  // Food point type

  if (!values.pointObject.id) {
    errors.pointObject = i18next.t('select_food_point_type');
  }

  // Box_office

  if (values.box_office.id === 0) {
    errors.box_office = i18next.t('cash_register_placeholder');
  }

  // Price_list_code

  if (values.price_list_code.name === '') {
    errors.price_list_code = i18next.t('validate_price_list');
  }

  // Payment type

  if (!values.payment_type.length) {
    errors.payment_type = i18next.t('payment_validate');
  }

  // Cooking time

  if (values.pointObject.id === 2 && !values.cooking_time) {
    errors.cooking_time = i18next.t('cooking_time_validate');
  } else if (
    values.pointObject.id === 2 &&
    !numberValidate(values.cooking_time)
  ) {
    errors.cooking_time = i18next.t('value_must_be_number');
  }

  // Warning

  if (values.popup_is_active && !values.popup_text) {
    errors.popup_text = i18next.t('warning_validate');
  }

  // Photos

  if (!values.name) {
    errors.photos = i18next.t('name_validate_secondary');
  }

  // Available ordering time

  if (!values.limit_hour) {
    errors.limit_hour = i18next.t('available_ordering_time_validate');
  }

  // Food category

  if (!values.food_types.length) {
    errors.food_types = i18next.t('food_types_validate');
  }

  // Days
  if (!values.days.length && values.working_days_all === false) {
    errors.days = i18next.t('week_days_validate');
  }

  return errors;
};
